import "./App.css";

import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  getDocs,
  enableIndexedDbPersistence,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

import React from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainMenu from "./Component/MainMenu/MainMenu.js";
import LevelMenu from "./Component/LevelMenu/LevelMenu.js";
import Level from "./Component/Level/Level.js";
import Dashboard from "./Component/Dashboard/Dashboard.js";
import Login from "./Component/Login/Login.js";
import LostPage from "./Component/404/404";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();

enableIndexedDbPersistence(db).catch((err) => {
  console.log(err);
});

async function getKelompok() {
  const querySnapshot = await getDocs(collection(db, "level"));

  return new Promise((resolve, reject) => {
    resolve(Promise.resolve(querySnapshot));
  });
}

function App() {
  window.onload = () => {
    getKelompok().then((data) => {
      const loading_page = document.getElementById("ipl-progress-indicator");
      loading_page.classList.add("available");
      loading_page.outerHTML = "";
    });
  };

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<MainMenu />} />
          <Route path="level" element={<LevelMenu />} />
          <Route path="level/:level" element={<Level />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="login" element={<Login />} />
          <Route path="*" element={<LostPage status={404} />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;

export { getKelompok, db, auth };
